import { action } from '@ember/object';
import Component from '@glimmer/component';

interface IArgs {
  onChange?: (checked: boolean, event: InputEvent) => void;
}

export default class BvCheckbox extends Component<IArgs> {
  @action
  onChange(e?: InputEvent) {
    if (e?.currentTarget && this.args.onChange) {
      this.args.onChange(
        (e.currentTarget as EventTarget & { checked: boolean }).checked ?? false,
        e
      );
    }
  }
}
